<template>
<section class="content">
    <div id="overlay"  v-if="loading">
      <div class="spinner"></div>
      <br/>
        <h4>Loading...</h4>
    </div>
    <div class="box box-info">
        <form>
          <div class="p-fluid p-formgrid p-grid">
            <div class="p-field p-col-12 p-md-2">
                 <label for="toDate">As On</label>
                 <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
                <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar" id="toDate" v-model="toDate"/>
              </div>
              <div class="p-field p-col-12 p-md-1 p-mt-5">
                 <Button type="submit"  @click.prevent="trialBalanceReport"
                 class="p-button-raised" label="Search" icon="pi pi-search"/>
               </div>
               <div class="p-field p-col-12 p-md-1 p-mt-5">
                 <Button @click.prevent="reset" v-if="this.trialBalanceList.length > 0"
                 class="p-button-raised p-button-warning" label="Reset" icon="pi pi-refresh"/>
              </div>
            </div>
        </form>
      <div class="p-field p-col-12 p-md-12">
        <Button class="p-button-raised" style="float:right;" @click="exportToPdf()" icon="pi pi-print"/>
      </div>
    <TreeTable :value="trialBalanceList" sortMode="multiple">
        <column  header="Particulars" field="name" :sortable="true" :expander="true"></column>
        <!-- <column  header="Opening Balance"></column> -->
        <column  header="Debit" bodyStyle="text-align: right" field="debitBalance" :sortable="true"></column>
        <column  header="Credit" bodyStyle="text-align: right" field="creditBalance" :sortable="true"></column>
        <!-- <column  header="Closing Balance" field="closingBalance"></column> -->
    </TreeTable>
    </div>
</section>
</template>
<script>
import TreeTable from 'primevue/treetable'
import Column from 'primevue/column'
import DatePicker from 'vue2-datepicker'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import $ from 'jquery'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'
export default {
  name: 'profitAndLossReport',
  data() {
    return {
      toDate: null,
      trialBalanceList: [],
      loading: false,
      englishDateEnabled: true
    }
  },
  mounted() {
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
  },
  methods: {
    async trialBalanceReport() {
      this.loading = true
      let response = await this.$store.dispatch('searchTrialBalanceOpeningReport', this.toDate)
      this.trialBalanceList = response.data.root
      this.loading = false
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    nepaliDate() {
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    },
    reset() {
      this.trialBalanceList = []
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    exportToPdf() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate
      }
      axios({
        url: globalKey + '/fileDownload/printFinalReport/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + this.$store.getters.fyId + '/' + this.$store.state.startDate + '/' + data.toDate + '/Trail Balance Opening',
        method: 'get',
        headers: { 'Accept': 'application/pdf', 'Authorization': localStorage.token },
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['Content-Disposition']
        let fileName = 'trailBalance.pdf'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    setEnglishDate() {
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    }
  },
  components: {
    TreeTable,
    Column,
    DatePicker,
    InputMask,
    Button
  }
}
</script>
<style  scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// trialBalanceOpeningReport.vue?4280771b